import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "icon", "label"]
  static values = { text: String }

  copy() {
    navigator.clipboard.writeText(this.textValue).then(() => {
      this.iconTarget.innerHTML = this.#checkIcon()
      this.labelTarget.textContent = "Copied!"

      setTimeout(() => {
        this.iconTarget.innerHTML = this.#copyIcon()
        this.labelTarget.textContent = "Copy"
      }, 2000)
    })
  }

  #copyIcon() {
    return `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
      d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"></path>`
  }

  #checkIcon() {
    return `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>`
  }
}
